import { Controller } from "@hotwired/stimulus"

const GAP = 14
const MARGIN = 8

// Hover cards and highlighting for the AI Discovery share donuts. Each slice
// has a server-rendered <template>; the card lives on <body> so the panel's
// overflow: hidden can't clip it.
export default class extends Controller {
  static targets = ["slice", "row", "tip"]

  connect() {
    this.card = document.createElement("div")
    this.card.className = "ai-share-tip"
    this.card.setAttribute("role", "tooltip")
    this.card.hidden = true
    document.body.appendChild(this.card)
    this.onScroll = () => this.hide()
    window.addEventListener("scroll", this.onScroll, { passive: true, capture: true })
  }

  disconnect() {
    window.removeEventListener("scroll", this.onScroll, { capture: true })
    this.card.remove()
  }

  show(event) {
    const anchor = event.currentTarget
    const tip = this.tipTargets.find(t => t.dataset.index === anchor.dataset.index)
    if (!tip) return

    this.highlight(anchor.dataset.index)
    this.card.replaceChildren(tip.content.cloneNode(true))
    this.card.hidden = false

    if (event.type === "mouseenter" && this.sliceTargets.includes(anchor)) {
      this.followPointer(event)
    } else {
      const box = anchor.getBoundingClientRect()
      this.place(box.left, box.right, box.top)
    }
  }

  move(event) {
    if (!this.card.hidden) this.followPointer(event)
  }

  hide() {
    this.card.hidden = true
    this.highlight(null)
  }

  followPointer(event) {
    this.place(event.clientX, event.clientX, event.clientY + GAP)
  }

  // Right of the anchor, or left of it when that would leave the viewport.
  place(left, right, top) {
    const { offsetWidth: width, offsetHeight: height } = this.card
    let x = right + GAP
    if (x + width > window.innerWidth - MARGIN) x = left - GAP - width
    const y = Math.min(top, window.innerHeight - MARGIN - height)
    this.card.style.left = `${Math.max(MARGIN, x)}px`
    this.card.style.top = `${Math.max(MARGIN, y)}px`
  }

  highlight(index) {
    if (index === null) delete this.element.dataset.active
    else this.element.dataset.active = index
    for (const el of [...this.sliceTargets, ...this.rowTargets]) {
      el.classList.toggle("is-active", el.dataset.index === index)
    }
  }
}
